export type OrderStatusKey =
  | "WAIT_APPROVE_ORDER"
  | "WAIT_CONFIRM_ORDER"
  | "CONFIRM_ORDER"
  | "OPEN_ORDER"
  | "IN_DELIVERY"
  | "DELIVERY_SUCCESS"
  | "SHOPAPP_CANCEL_ORDER"
  | "COMPANY_CANCEL_ORDER"
  | "REJECT_ORDER"
  | "WAIT_APPROVE_OVER_CREDIT"
  | "WAIT_APPROVE_SALE_ORDER"
  | "APPROVED_ORDER"
  | "REJECT_OVER_CREDIT"
  | "APPROVE_SALE_ORDER"
  | "REJECT_SALE_ORDER"
  | "EXPIRED";

export type OrderPaymentMethodName = "CASH" | "CREDIT";

export type OrderPaymentStatusKey = "WAITING_PAID" | "ALREADY_PAID";

export type OrderDeliveryDestKey = "SHOP" | "FACTORY" | "OTHER";

export const ORDER_STATUS = {
  WAIT_APPROVE_ORDER: {
    name_default: "รออนุมัติคำสั่งซื้อพิเศษ",
    name_icpl: "รออนุมัติคำสั่งซื้อพิเศษ",
    name_icpi: "รออนุมัติคำสั่งซื้อพิเศษ",
    name_icpf: "รออนุมัติคำสั่งซื้อพิเศษ",
    color: "#FFEBDB",
    text_color: "#F56A00",
    group_icpl: null,
    group_default: null,
  },
  WAIT_CONFIRM_ORDER: {
    name_default: "รอร้านยืนยันคำสั่งซื้อ",
    name_icpl: "รอร้านยืนยันคำสั่งซื้อ",
    name_icpi: "รอยืนยันคำสั่งซื้อ",
    name_icpf: "รอยืนยันคำสั่งซื้อ",
    color: "#FFF5C2",
    text_color: "#A38800",
    group_icpl: null,
    group_default: null,
  },
  CONFIRM_ORDER: {
    name_default: "ยืนยันคำสั่งซื้อแล้ว",
    name_icpl: "อนุมัติคำสั่งซื้อแล้ว",
    name_icpi: "ยืนยันคำสั่งซื้อแล้ว",
    name_icpf: "ยืนยันคำสั่งซื้อแล้ว",
    color: "#E5F0FF",
    text_color: "rgb(43, 113, 218)",
    group_icpl: "APPROVED_ORDER",
    group_default: "APPROVED_ORDER",
  },
  WAIT_APPROVE_OVER_CREDIT: {
    name_default: "รอพิจารณาวงเงิน",
    name_icpl: "รออนุมัติวงเงิน",
    name_icpi: "รอพิจารณาวงเงิน",
    name_icpf: "รอพิจารณาวงเงิน",
    color: "#FFEBDB",
    text_color: "#F56A00",
    group_icpl: null,
    group_default: null,
  },
  WAIT_APPROVE_SALE_ORDER: {
    name_default: "รออนุมัติใบสั่งขาย",
    name_icpl: "รออนุมัติใบสั่งขาย",
    name_icpi: "รออนุมัติใบสั่งขาย",
    name_icpf: "รออนุมัติใบสั่งขาย",
    color: "#FFEBDB",
    text_color: "#F56A00",
    group_icpl: null,
    group_default: null,
  },
  APPROVE_SALE_ORDER: {
    name_default: "อนุมัติคำสั่งซื้อแล้ว",
    name_icpl: "อนุมัติคำสั่งซื้อแล้ว",
    name_icpi: "ยืนยันคำสั่งซื้อแล้ว",
    name_icpf: "ยืนยันคำสั่งซื้อแล้ว",
    color: "#E5F0FF",
    text_color: "#2B71DA",
    group_icpl: "APPROVED_ORDER",
    group_default: "APPROVED_ORDER",
  },
  APPROVED_ORDER: {
    name_default: "อนุมัติคำสั่งซื้อแล้ว",
    name_icpl: "อนุมัติคำสั่งซื้อแล้ว",
    name_icpi: "ยืนยันคำสั่งซื้อแล้ว",
    name_icpf: "ยืนยันคำสั่งซื้อแล้ว",
    color: "#E5F0FF",
    text_color: "#2B71DA",
    group_icpl: "APPROVED_ORDER",
    group_default: "APPROVED_ORDER",
  },
  OPEN_ORDER: {
    name_default: "รอรถเข้ารับสินค้า",
    name_icpl: "เปิดรายการคำสั่งซื้อแล้ว",
    name_icpi: "รอรถเข้ารับสินค้า",
    name_icpf: "รอรถเข้ารับสินค้า",
    color: "#F2ECFE",
    text_color: "#903AB0",
    group_icpl: null,
    group_default: null,
  },
  IN_DELIVERY: {
    name_default: "กำลังจัดส่ง",
    name_icpl: "กำลังจัดส่ง",
    name_icpi: "รอขึ้นสินค้า",
    name_icpf: "รอขึ้นสินค้า",
    color: "#FFF5C2",
    text_color: "#A38800",
    group_icpl: null,
    group_default: null,
  },
  DELIVERY_SUCCESS: {
    name_default: "ลูกค้ารับสินค้าแล้ว",
    name_icpl: "รับสินค้าแล้ว",
    name_icpi: "ขึ้นสินค้าเรียบร้อยแล้ว",
    name_icpf: "ขึ้นสินค้าเรียบร้อยแล้ว",
    color: "#E3FDEB",
    text_color: "#3A9757",
    group_icpl: null,
    group_default: null,
  },
  SHOPAPP_CANCEL_ORDER: {
    name_default: "ยกเลิกคำสั่งซื้อโดยร้านค้า",
    name_icpl: "ยกเลิกคำสั่งซื้อโดยร้านค้า",
    name_icpi: "ยกเลิกคำสั่งซื้อโดยร้านค้า",
    name_icpf: "ยกเลิกคำสั่งซื้อโดยร้านค้า",
    color: "#FDE2E2",
    text_color: "#F24040",
    group_icpl: null,
    group_default: null,
  },
  COMPANY_CANCEL_ORDER: {
    name_default: "ยกเลิกคำสั่งซื้อโดยบริษัท",
    name_icpl: "ยกเลิกคำสั่งซื้อโดยบริษัท",
    name_icpi: "ยกเลิกคำสั่งซื้อโดยบริษัท",
    name_icpf: "ยกเลิกคำสั่งซื้อโดยบริษัท",
    color: "#FDE2E2",
    text_color: "#F24040",
    group_icpl: "COMPANY_CANCEL_ORDER",
    group_default: "COMPANY_CANCEL_ORDER",
  },
  SALE_CANCEL_ORDER: {
    name_default: "ยกเลิกคำสั่งซื้อโดยเซลล์",
    name_icpl: "ยกเลิกคำสั่งซื้อโดยเซลล์",
    name_icpi: "ยกเลิกคำสั่งซื้อโดยเซลล์",
    name_icpf: "ยกเลิกคำสั่งซื้อโดยเซลล์",
    color: "#FDE2E2",
    text_color: "#F24040",
    group_icpl: null,
    group_default: null,
  },
  REJECT_ORDER: {
    // name_default: "ไม่อนุมัติคำสั่งซื้อ",
    // name_icpl: "ไม่อนุมัติคำสั่งซื้อ",
    // name_icpi: "ไม่อนุมัติคำสั่งซื้อ",
    // name_icpf: "ไม่อนุมัติคำสั่งซื้อ",
    name_default: "ยกเลิกคำสั่งซื้อโดยบริษัท",
    name_icpl: "ยกเลิกคำสั่งซื้อโดยบริษัท",
    name_icpi: "ยกเลิกคำสั่งซื้อโดยบริษัท",
    name_icpf: "ยกเลิกคำสั่งซื้อโดยบริษัท",
    color: "#FDE2E2",
    text_color: "#F24040",
    group_icpl: "COMPANY_CANCEL_ORDER",
    group_default: "COMPANY_CANCEL_ORDER",
  },
  REJECT_OVER_CREDIT: {
    // name_default: "ไม่อนุมัติวงเงินเครดิต",
    name_default: "ไม่อนุมัติวงเงินเกิน",
    name_icpl: "ไม่อนุมัติวงเงินเกิน",
    name_icpi: "ไม่อนุมัติวงเงินเกิน",
    name_icpf: "ไม่อนุมัติวงเงินเกิน",
    color: "#FDE2E2",
    text_color: "#F24040",
    group_icpl: null,
    group_default: null,
  },
  REJECT_SALE_ORDER: {
    // name_default: "ไม่อนุมัติคำสั่งขาย",
    name_default: "ยกเลิกคำสั่งซื้อโดยบริษัท",
    name_icpl: "ยกเลิกคำสั่งซื้อโดยบริษัท",
    name_icpi: "ยกเลิกคำสั่งซื้อโดยบริษัท",
    name_icpf: "ยกเลิกคำสั่งซื้อโดยบริษัท",
    color: "#FDE2E2",
    text_color: "#F24040",
    group_icpl: "COMPANY_CANCEL_ORDER",
    group_default: "COMPANY_CANCEL_ORDER",
  },
  EXPIRED: {
    name_default: "หมดอายุ",
    name_icpl: "หมดอายุ",
    name_icpi: "หมดอายุ",
    name_icpf: "หมดอายุ",
    color: "#D3D3D3",
    text_color: "#808080",
    group_icpl: null,
    group_default: null,
  },
};

export const ORDER_PAYMENT_STATUS = {
  WAITING_PAID: {
    name_default: "ยังไม่ได้ชำระเงิน",
    color: "#FFC804",
  },
  ALREADY_PAID: {
    name_default: "ชำระเงินแล้ว",
    color: "#FFC804",
  },
};

export const ORDER_PAYMENT_METHOD_NAME = {
  CASH: "เงินสด",
  CREDIT: "เครดิต",
};

export const ORDER_DELIVERY_DEST_METHOD_NAME = {
  SHOP: "จัดส่งที่ร้าน",
  FACTORY: "รับที่โรงงาน ",
  OTHER: "ส่งรับที่อื่นๆ ",
};

export const getOrderStatusInfo = (statusKey: string, isOverCredit?: boolean) => {
  if (statusKey === "APPROVED_ORDER" && isOverCredit === false) {
    return ORDER_STATUS["CONFIRM_ORDER"];
  }
  return ORDER_STATUS[statusKey];
};
